import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="bg-white py-20 sm:py-24" aria-labelledby="garantia-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-93" data-mp="1o2lsv5zg4o2z">
      <div className="mx-auto max-w-4xl px-6" data-id="element-94" data-mp="221249a8972rg">
        <Reveal data-id="element-95" data-mp="1x5d5h9425pw7">
          <div className="rounded-3xl border border-mint-200 bg-mint-50 px-8 py-12 text-center sm:px-14" data-id="element-96" data-mp="1x4uybhfuxr9i">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-mint-600 text-white" data-id="element-97" data-mp="19f0lv0zga4ps">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-98" data-mp="14dtgt9oozjmt" />
            </span>
            <h2 id="garantia-title" className="mt-6 font-display text-3xl text-ink sm:text-4xl" data-id="element-99" data-mp="1j6n8dth8nq7u">
              Garantía de 7 días
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-100" data-mp="qnhmr58jrat1">
              Abrís los 6 tomos. Revisás los 5 bonos. Los usás en tu vida si
              querés. Si en 7 días no es lo que esperabas,{' '}
              <strong className="font-semibold text-ink" data-id="element-101" data-mp="oz03pw3z42ou">
                
te devolvemos el 100%
              </strong>
              .
            </p>
            <p className="mt-4 font-display text-2xl text-mint-700" data-id="element-102" data-mp="ypl33lrh1b8t">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
            
          </div>
        </Reveal>
      </div>
    </section>;
}